/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './resolveIdentity.defs.js'
export * as $defs from './resolveIdentity.defs.js'
